import type { FC, ReactNode } from "react";
import type { UseFormRegisterReturn } from "react-hook-form";
import { twMerge } from "tailwind-merge";

import { BUTTON_EVENT_CATEGORY, type TrackingProps, trackEvent } from "utils/amplitude";

type LabeledCheckboxProps = TrackingProps & {
  className?: string;
  disabled?: boolean;
  registration: UseFormRegisterReturn;
  children: ReactNode;
};

// TODO: replace with MDS Checkbox component
export const LabeledCheckbox: FC<LabeledCheckboxProps> = ({
  className,
  disabled,
  registration,
  eventName,
  eventProps = {},
  children,
}) => {
  const registeredChangeHandler = registration.onChange;
  const handleChange = eventName
    ? (e: React.ChangeEvent<HTMLInputElement>) => {
        if (registeredChangeHandler) registeredChangeHandler(e);
        trackEvent(eventName, {
          ...BUTTON_EVENT_CATEGORY,
          isEnabled: e.target.checked,
          ...eventProps,
        });
      }
    : registeredChangeHandler;

  return (
    <label
      className={twMerge("flex items-center gap-2", disabled && "text-black-tint-55", className)}
    >
      <input disabled={disabled} type="checkbox" {...registration} onChange={handleChange} />
      {children}
    </label>
  );
};
